import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { startTimeOptions, cutGapOptions, qualityOptions } from './config/options';
import { creatGifTask, getEndcardInfo } from './api/index.js';
import { lang as _lang } from './utils/lang.js';
import _ from 'lodash';

import GifPreviewer from './components/previewer.vue';

export default {
  components: {
    GifPreviewer: GifPreviewer
  },
  data: function data() {
    return {
      formValue: {
        window_size: '720x1280,1200x627',
        start_time: 200,
        frames: 8,
        quality: 3,
        language: ''
      },
      urlLang: [],
      startTimeOptions: startTimeOptions,
      cutGapOptions: cutGapOptions,
      transLoading: false,
      transGifList: [],
      authToken: ''
    };
  },

  methods: {
    qualityOptions: qualityOptions,
    lang: function lang(key) {
      return _lang(key, this.$route.query.lang === 'en' ? 'en' : 'cn');
    },
    closeDialog: function closeDialog() {
      console.log('iframe 调用关闭方法');
      window.parent.postMessage({
        type: 'ec2gif:close'
      }, '*');
    },
    handlePreview: function handlePreview() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs['gif-form'].validate();

              case 2:
                valid = _context.sent;

                if (valid && !_this.transLoading) {
                  _this.ec2Gif();
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.parent.postMessage({
                  type: 'ec2gif:success',
                  list: _this2.transGifList
                }, '*');

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    ec2Gif: function ec2Gif() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var postdata, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                postdata = _extends({
                  url: _this3.innerPreviewUrl,
                  token: _this3.authToken || ''
                }, _this3.formValue, {
                  language: _this3.formValue.language,
                  ext_data: _this3.$route.query.ext_data || '{}'
                });

                _this3.transLoading = true;
                _this3.transGifList = [];
                _context3.next = 6;
                return creatGifTask(postdata, _this3.skinSetting);

              case 6:
                res = _context3.sent;

                console.log(res, '转换结果');
                _this3.transLoading = false;
                if (_.get(res, 'data.code') === 200) {
                  _this3.transGifList = _.get(res, 'data.data.gif_details');
                } else {
                  _this3.$message({
                    type: 'error',
                    message: _.get(res, 'data.msg') || 'faild'
                  });
                }
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

                _this3.transLoading = false;
                console.log(_context3.t0);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 12]]);
      }))();
    },
    fmtSize: function fmtSize(bytes) {
      var a = ['Byte', 'K', 'M'];
      var i = 0;
      if (Number(bytes) !== 0) {
        while (Number(bytes) > 0 && i < 2) {
          bytes /= 1024;
          // eslint-disable-next-line no-plusplus
          i++;
        }
        var sTemp = Number(bytes).toFixed(1) + a[i];
        return sTemp;
      } else if (Number(bytes) === 0) {
        return '0Byte';
      }
      return '-';
    },
    getSuggestContent: function getSuggestContent() {
      if (this.currentGifSize > 1 && this.currentGifSize < 5) return this.lang('suggestSize');
      if (this.currentGifSize >= 5) return this.lang('creativeMaxSize');
      return '';
    },
    getLangByUrl: function getLangByUrl() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var postdata, res, languages;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                postdata = {
                  url: _this4.$route.query.url
                };
                _context4.next = 3;
                return getEndcardInfo(postdata);

              case 3:
                res = _context4.sent;

                if (_.get(res, 'data.code') === 0) {
                  languages = (_.get(res, 'data.data.languages') || []).map(function (val) {
                    return {
                      label: val,
                      value: val
                    };
                  });

                  _this4.urlLang = languages;
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  computed: {
    popperClass: function popperClass() {
      if (this.skinSetting === 'ss') {
        return 'ec-2-gif-selector-layer--' + this.skinSetting;
      }
      return 'ec-2-gif-selector-layer--portal';
    },
    rules: function rules() {
      return {
        language: [{ required: true, message: this.lang('langEmpty'), trigger: 'change' }]
      };
    },
    currentGif: function currentGif() {
      if (this.transGifList.length === 0) return {};
      var max = _.max(this.transGifList.map(function (item) {
        return item.size;
      }));
      return this.transGifList.filter(function (item) {
        return item.size === max;
      })[0];
    },
    currentGifSize: function currentGifSize() {
      return ((this.currentGif.size || 0) / 1024 / 1024).toFixed(0);
    },

    // 5-15张
    cutNumOptions: function cutNumOptions() {
      var arr = [];
      for (var i = 0; i <= 15; i++) {
        if (i >= 5) {
          arr.push(i);
        }
      }
      return arr;
    },
    langOptions: function langOptions() {
      if (this.urlLang.length > 0) {
        return this.urlLang;
      }
      if (this.$route.query.lang_option) {
        var temp = this.$route.query.lang_option.split(',');
        temp = temp.map(function (item) {
          return {
            value: item,
            label: item
          };
        });
        return temp;
      }
      return [];
    },
    pageLanguage: function pageLanguage() {
      return this.$route.query.lang || 'en';
    },
    skinSetting: function skinSetting() {
      return this.$route.query.skin === 'ss' ? 'ss' : 'portal';
    },
    innerPreviewUrl: function innerPreviewUrl() {
      // 优先使用接口获取预览地址
      return this.$route.query.url;
    },
    canSubmit: function canSubmit() {
      return this.transGifList.length > 0 && this.currentGifSize && this.currentGifSize < 5;
    }
  },
  mounted: function mounted() {
    var self = this;
    this.authToken = this.$route.query.token || '';
    this.getLangByUrl();

    window.addEventListener('message', function (event) {
      if (event.data.type === 'ec2gif:token') {
        self.authToken = event.data.token;
      }
    });
  }
};